module.exports = __webpack_public_path__ + "img/BVBANK.12967f16.svg";